import React, {
  FC, useEffect,
} from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { v4 as uuid } from 'uuid';
import { RowLeft } from '../Styles';
import OptionButton from '../components/Button/OptionButton';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import Q18 from '../Q18';
import Q21 from '../Q21';
import UserReply from '../components/Reply/UserReply';
import LeftToRight from '../components/Animation/LeftToRight';
import RobotReply from '../components/Reply/RobotReply';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import { updateFoodifoxData } from '../../../../../lib/axios/FoodifoxDataAPI';

/**
 * 离线二维码
 */
const Q9: FC<Props> = ({
  cabId,
  boxOfflineCode,
  addElement,
  setTargetPage,
  deviceCode,
  h5Platform,
  boxList,
  sessionId,
  enterPhoneNumber,
}) => {
  const option1 = { zhValue: '柜门已打开', enValue: 'Door opened' };
  const option2 = { zhValue: '柜门未打开', enValue: 'Door hasn’t opened' };
  // 更新订单
  const [updateOrder] = updateFoodifoxData('/fox3PDAi/updateOrder');

  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '请使用柜子上的扫码器扫描下方的二维码。';
    const langEn = 'Please use scanner located on the locker and scan the below QR Code.';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ alignItems: 'center', marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: getWindowWidth() * 0.58 }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q9 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          {
            boxOfflineCode.map(({ qrCode }) => {
              return (
                <RowLeft key={'offline-pwd-code-' + (new Date().getTime())} style={{ alignItems: 'center' }}>
                  <RobotReply style={{ padding: 25, maxWidth: 'unset', width: getWindowWidth() * 0.58 - 20 }}>
                    <QRCodeSVG
                      key={qrCode}
                      level={'H'}
                      value={qrCode}
                      width={getWindowWidth() * 0.58 - 20}
                      height={getWindowWidth() * 0.58 - 20}
                    />
                  </RobotReply>
                </RowLeft>
              );
            })
          }
        </LeftToRight>
      );
    }, 400);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <OptionButton
              langZh={option1.zhValue}
              langEn={option1.enValue}
              flowId={flowId}
              callback={() => {
                updateOrder({
                  param: {
                    boxNumberCabList: boxList.map((vo) => { return { ...vo, deviceCode, sessionId }; }),
                  },
                });
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q9 - user: ' + option1.enValue, sessionId);
                addElement(
                  <UserReply
                    langZh={option1.zhValue}
                    langEn={option1.enValue}
                  />
                );
                addElement(
                  <Q21
                    addElement={addElement}
                    setTargetPage={setTargetPage}
                    cabId={cabId}
                    h5Platform={h5Platform}
                    deviceCode={deviceCode}
                    sessionId={sessionId}
                    enterPhoneNumber={enterPhoneNumber}
                  />
                );
              }}
            />
          </RowLeft>
          <RowLeft>
            <OptionButton
              langZh={option2.zhValue}
              langEn={option2.enValue}
              flowId={flowId}
              callback={() => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q9 - user: ' + option2.enValue, sessionId);
                addElement(
                  <UserReply
                    langZh={option2.zhValue}
                    langEn={option2.enValue}
                  />
                );
                addElement(
                  <Q18
                    cabId={cabId}
                    addElement={addElement}
                    h5Platform={h5Platform}
                    deviceCode={deviceCode}
                    sessionId={sessionId}
                  />
                );
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 600);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  boxOfflineCode: {
    qrCode: string;
    boxNumber: string;
  }[];
  boxList: { cabId: number; boxNumber: string }[];
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  deviceCode: string;
  h5Platform: number;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q9;
